/**
 * Created by noOne on 15/02/2018.
 */
"use strict";

import StackedSprite    from "./../game/StackedSprite";
import StackedDuplicate from "./../game/StackedDuplicate";
import Player           from "./../game/Player";
import Shake            from "./../game/Shake";

export default class GameScene extends P3.Scene {
    constructor() {
        super();

        this._player = null;

        this._stackedSprites = [];
        this._stackedHolder = new PIXI.Container();

        this._bgHolder = new PIXI.Container();

        this._bg = null;

        this._testPos = [{"x":895,"y":735},{"x":1609,"y":415},{"x":1769,"y":15},{"x":1178,"y":126},{"x":340,"y":593},{"x":1292,"y":447},{"x":1167,"y":214},{"x":1613,"y":526},{"x":1603,"y":404},{"x":762,"y":430},{"x":280,"y":269},{"x":346,"y":425},{"x":110,"y":677},{"x":271,"y":372},{"x":561,"y":573},{"x":814,"y":129},{"x":285,"y":700},{"x":1490,"y":533},{"x":1367,"y":458},{"x":471,"y":538},{"x":95,"y":172},{"x":319,"y":696},{"x":842,"y":667},{"x":1227,"y":90},{"x":1110,"y":532},{"x":1204,"y":749},{"x":1387,"y":62},{"x":347,"y":688},{"x":1537,"y":458},{"x":597,"y":621}];

    }

    init() {

        Common.renderer.backgroundColor = 0xaccc2e;

        this.addChild(this._stackedHolder);

        // const pos = [];
        console.log("foo");

        for (let i = 0; i < 30; i++) {

            let stacked = i < 15 ? new StackedSprite("house", 64, 64) : new StackedSprite("tree", 10, 10);
            this._stackedHolder.addChild(stacked);

            //  stacked.x = Common.STAGE_WIDTH * 0.5 + P3.math.randomInt(-Common.STAGE_WIDTH * 0.5, Common.STAGE_WIDTH * 0.5);
            // stacked.y = Common.STAGE_HEIGHT * 0.5 + P3.math.randomInt(-Common.STAGE_HEIGHT * 0.5, Common.STAGE_HEIGHT * 0.5);

            this._stackedSprites.push(stacked);

            //pos.push(new PIXI.Point(stacked.x, stacked.y));


            stacked.x = this._testPos[i].x;
            stacked.y = this._testPos[i].y;
        }

        // console.log(JSON.stringify(pos));

        this._player = new Player();
        this._stackedHolder.addChild(this._player);

        this._player.x = Common.STAGE_WIDTH * 0.5;
        this._player.y = Common.STAGE_HEIGHT * 0.5;
        this._player.setRotation(Math.PI);

        this._stackedHolder.x = Common.STAGE_WIDTH * 0.5;
        this._stackedHolder.y = Common.STAGE_HEIGHT * 0.5;

        this.testNoise();
        /*
         let sp1 = P3.utils.sprite(PIXI.Texture.WHITE, this._stackedHolder, new PIXI.Point(0.5, 0.5));
         sp1.tint = 0xff0000;
         sp1.scale.set(10);
         sp1.x = Common.STAGE_WIDTH * 0.5;
         sp1.y = Common.STAGE_HEIGHT * 0.5;
         sp1.x -= 75;

         let sp2 = P3.utils.sprite(PIXI.Texture.WHITE, this._stackedHolder, new PIXI.Point(0.5, 0.5));
         sp2.tint = 0x0000ff;
         sp2.scale.set(10);
         sp2.x = Common.STAGE_WIDTH * 0.5;
         sp2.y = Common.STAGE_HEIGHT * 0.5;
         sp2.x += 75;

         if (Common.bump.hitTestRectangle(sp1, sp2)) {
         //hit = "up";
         console.log("bump");
         }
         */
    }

    testNoise() {
        this._shake = new Shake();
        this._shake.setTarget(this._stackedHolder);
        this._shake.setRotCentre(this._player);
        //  this._shake.trauma = 1;
        this._shake.useRotation = true;
    }

    destroy() {
        super.destroy({children: true});
    }

    appear() {
        super.appear();
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
    }

    update() {

        //this._player.test();

        //test shake
        if (Common.input.isKeyPressed(32)) {//w
            this._shake.trauma += 0.25;
        }

        this._shake.update(deltaTime);

        //--depth sort--//
        this._stackedHolder.children.sort((a, b)=> {
            return a.y - b.y;
        });

        let dir = null;
        if (Common.input.isKeyDown(81)) {
            dir = -1;
        } else if (Common.input.isKeyDown(69)) {
            dir = 1;
        }

        dir = 0.1;

        //--cycle array checking all cardinal directions for collisions--//
        let hit = null;
        for (let i = 0; i < this._stackedSprites.length; i++) {
            let ss = this._stackedSprites[i];

            let result = P3.utils.collide(this._player.collisionRect, ss.collisionRect);
            if (result) {

                hit = true;

                if (this._player.x < ss.x) this._player.x -= 1;
                if (this._player.x > ss.x) this._player.x += 1;
                if (this._player.y < ss.y) this._player.y -= 1;
                if (this._player.y > ss.y) this._player.y += 1;

            }

        }

        //no need to update rotation if rotate key isn't down or we are touching a wall
        if (dir && !hit) {
            for (let i = 0; i < this._stackedSprites.length; i++) {
                let ss = this._stackedSprites[i];
                ss.update(dir);
                this._rotateAround(this._player.x, this._player.y, deltaTime * dir, ss);
            }

            //this._bg.rotation += deltaTime * dir;
        }

        //if (hit) console.log(hit);

        //--check for collisions--//
        if (Common.input.isKeyDown(87) && !hit) {//w
            // this._stackedHolder.y += 2;
            this._player.y -= 2;
            this._player.setRotation(0);
        }

        if (Common.input.isKeyDown(83) && !hit) {//s
            // this._stackedHolder.y -= 2;
            this._player.y += 2;
            this._player.setRotation(Math.PI);
        }

        if (Common.input.isKeyDown(65) && !hit) {//a
            // this._stackedHolder.x += 2;
            this._player.x -= 2;
            this._player.setRotation(Math.PI * 0.5);
        }

        if (Common.input.isKeyDown(68) && !hit) {//d
            // this._stackedHolder.x -= 2;
            this._player.x += 2;
            this._player.setRotation(-Math.PI * 0.5);
        }

        this._stackedHolder.x = -this._player.x;
        this._stackedHolder.y = -this._player.y;

    }

    end() {
        this.signals.next.dispatch(this);
    }

    /**
     * @param cx - pivot x
     * @param cy - pivot y
     * @param angle - angle to rotate by
     * @param p - point to rotate
     * @returns {*}
     */
    _rotateAround(cx, cy, angle, p) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);

        // translate point back to origin:
        p.x -= cx;
        p.y -= cy;

        // rotate point
        let xnew = p.x * c - p.y * s;
        let ynew = p.x * s + p.y * c;

        // translate point back:
        p.x = xnew + cx;
        p.y = ynew + cy;

        return p;
    }

}
